import { safeSessionStorage } from './safe-storage';

/**
 * SessionStorage for storing string values
 * store things relevant for a session
 */
export function SessionStorage(
  target: Object, // The prototype of the class
  decoratedPropertyName: string // The name of the property
) {
  // get and set methods
  Object.defineProperty(target, decoratedPropertyName, {
    get: function () {
      return safeSessionStorage.getItem(decoratedPropertyName) || '';
    },
    set: function (newValue) {
      safeSessionStorage.setItem(decoratedPropertyName, newValue);
    },
  });
}
